const NotFoundMessageStatusTypes = {
    USER_NOT_FOUND: "USER_NOT_FOUND"
} as const;
export type NotFoundMessageStatusTypes = keyof typeof NotFoundMessageStatusTypes;

export const NotFoundException = (messageCode: NotFoundMessageStatusTypes | string, message: string) => ({
    error: new Error(message),
    status: messageCode,
    code: 404
})